import { render, staticRenderFns } from "./StyleToggleControl.vue?vue&type=template&id=063ce31a&scoped=true&"
import script from "./StyleToggleControl.vue?vue&type=script&lang=js&"
export * from "./StyleToggleControl.vue?vue&type=script&lang=js&"
import style0 from "./StyleToggleControl.vue?vue&type=style&index=0&id=063ce31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ce31a",
  null
  
)

export default component.exports